import React, { useState } from 'react'
import ModalInc from '../../../../../shared-ui/ModalInc'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { Autocomplete, TextField } from '@mui/material';
import { ValidatorForm } from 'react-material-ui-form-validator';
import Grid from "@material-ui/core/Grid";
import AlertDialog from '../../../../../components/AlertDialog/index.es6';
import { CircularProgress } from '@material-ui/core';
import { Lawyers } from './Lawyers';
import { getPartnerGuid } from '../../../../../lib/access.es6';
import { sendEmail } from '../../../../../lib/requests.es6';

const AssignLawyerClaim = (props) => {
  const [selectedLawyer, setSelectedLawyer] = useState(null);

  const handleAssignLawyer = () => {
    console.log("Assigned Lawyer: ", selectedLawyer);
    const payload = {
      "additional_details": {
        "lawyer_email": selectedLawyer.email,
        "lawyer_name": selectedLawyer.name,
        "lawyer_phone_number": selectedLawyer.phoneNumber,
        "claim_guid": props.claimguid
      }

    }
    console.log("lawyer payload", payload);
    props.assignLawyer(payload);

    // Email payload
    const emailPayload = {
      entity_guid: props.claimguid,
      partner_guid: getPartnerGuid(),
      email_code: "ASS_LA_CL", // pass this as a prop
      template_type: "Customer",
      email_recipients: [selectedLawyer.email],
      //email_template_guid: props.emailTemplateGuid // pass this as a prop
    };
    sendEmail(emailPayload)
      .then(res => console.log('Email sent', res))
      .catch(err => console.error('Email error', err));
    //reset()
  }
  const handleLawyerAssignedSuccessfuly = () => {
    props.resetAddLawyerSuccessAlert();
    props.toggleAssignLawyerDialog();
    window.location.reload();
  }
  const handleAssignLawyerError = () => {
    props.resetAddLawyerErrorAlert();
  }
  return (
    <>
      <AlertDialog
        custom
        show={props.showAddLawyerProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2> Assigning a Lawyer to Claim ...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showAddLawyerSuccessAlert}
        size="sm"
        title={'Lawyer Assigned Successfully'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleLawyerAssignedSuccessfuly() }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={true}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      >

      </AlertDialog>

      <AlertDialog
        show={props.showAddLawyerErrorAlert}
        danger
        title={'Error assigning lawyer'}
        onConfirm={() => handleAssignLawyerError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >

        {props.addLawyerError ? props.addLawyerError.message : ''}
      </AlertDialog>
      <ModalInc
        modalTitle="Assign Lawyer"
        subTitle="Fill the below field to assign a lawyer"
        open={props.openAssignLawyerDialog}
        onClose={props.toggleAssignLawyerDialog}
        fullWidth
      >
        <ValidatorForm onSubmit={() => handleAssignLawyer()} >

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Autocomplete
                options={Lawyers}
                getOptionLabel={(option) => option.name}
                sx={{ width: "100%" }}
                onChange={(event, value) => setSelectedLawyer(value)}
                renderInput={(params) => <TextField {...params} label="Select Lawyer" variant="outlined" />}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} >
            <Grid item xs={12} sm={6} md={6}>

            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={8} md={8}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    type='submit'
                    style={{ marginTop: "20px", float: "right" }}
                    disabled={!selectedLawyer}
                  >
                    Assign Lawyer
                  </ButtonInc>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{ marginTop: "20px" }}
                    onClick={props.toggleAssignLawyerDialog}
                  >
                    Cancel
                  </ButtonInc>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </ValidatorForm>

      </ModalInc>
    </>
  )
}

export default AssignLawyerClaim